import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import styles from './AnswerForm.module.css'

import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import Button from 'Design/components/Button'
import FormErrorText from 'Design/components/FormErrorText'

import TrixEditor from 'Src/b/components/TrixEditor'
import { useUploadImageMutation } from '../answers.service'

const AnswerForm = (props) => {
  const { isLoading, onSubmit, onDeleteAnswer, onSaveandAddNewAnswer } = props

  const {
    register,
    control,
    handleSubmit,
    formState: { isSubmitting, errors }
  } = useFormContext()

  const [uploadImage, uploadImageResult] = useUploadImageMutation()
  const disableSubmitButton = isSubmitting || isLoading || uploadImageResult.isLoading

  const handleImageUpload = async (event) => {
    const attachment = event.attachment

    if (attachment.file) {
      try {
        const formData = new FormData()
        formData.append('file', attachment.file)

        const data = await uploadImage(formData).unwrap()
        const { fileUrl } = data

        attachment.setAttributes({
          url: fileUrl,
          href: fileUrl
        })
      } catch (error) {
        console.error('Error while uploading image to server', error)
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={errors.name}>
        <Label>Answer Title</Label>
        <Input className={styles.TitleInput} {...register('name')} />
        {errors.name && <FormErrorText>{errors.name.message}</FormErrorText>}
      </FormControl>

      <FormControl isInvalid={errors.content}>
        <Controller
          control={control}
          name='content'
          render={({ field: { value, onChange } }) => {
            return <TrixEditor defaultValue={value} onChange={onChange} onImageUpload={handleImageUpload} />
          }}
        />
        {errors.content && <FormErrorText>{errors.content.message}</FormErrorText>}
      </FormControl>

      <div className={styles.ButtonContainer}>
        <Button variant='primary' type='submit' disabled={disableSubmitButton}>
          Save
        </Button>

        {onSaveandAddNewAnswer && (
          <Button
            className={styles.AddNewAnswerButton}
            variant='secondary'
            onClick={handleSubmit(onSaveandAddNewAnswer)}
            disabled={disableSubmitButton}
          >
            Save and add new answer
          </Button>
        )}

        {onDeleteAnswer && (
          <Button className={styles.DeleteButton} variant='link-danger' onClick={onDeleteAnswer}>
            Delete
          </Button>
        )}
      </div>
    </form>
  )
}

export default AnswerForm
